import cx from "classnames";
import type { FabMenuItem } from "../../FabButton.state";

type FabButtonMenuItemProps = {
  item: FabMenuItem;
  expanded: boolean;
};

const FabButtonMenuItem = ({ item, expanded }: FabButtonMenuItemProps) => {
  const hasDescription = Boolean(item.description);

  return (
    <button
      type="button"
      onClick={item.onClick}
      className={cx(
        "group flex w-full gap-3 rounded-xl px-3 py-2 text-left transition-colors focus-visible:outline-none cursor-pointer",
        hasDescription ? "items-start" : "items-center",
        expanded
          ? "hover:bg-action-hover focus-visible:bg-action-hover"
          : "hover:bg-white/10 focus-visible:bg-white/10"
      )}
    >
      <span
        className={cx(
          "grid size-9 shrink-0 place-items-center rounded-full text-primary transition-colors group-hover:bg-primary group-hover:text-white",
          hasDescription && "mt-0.5",
          expanded ? "bg-action-hover" : "bg-white/10"
        )}
      >
        {item.icon}
      </span>
      <span className="min-w-0 flex-1">
        <span
          className={cx(
            "block truncate text-sm font-medium",
            expanded ? "text-text-primary" : "text-white"
          )}
        >
          {item.label}
        </span>
        {item.description && (
          <span
            className={cx(
              "block whitespace-normal wrap-break-words text-xs",
              expanded ? "text-text-secondary" : "text-white/60"
            )}
          >
            {item.description}
          </span>
        )}
      </span>
      {item.endAdornment}
    </button>
  );
};

export default FabButtonMenuItem;
